export const setCookie = (cvalue: any, cookie: string) => {
    const cname = cookie;
    const exdays = 1;
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;SameSite=none"; 
}
export const getCookie = (name: string) => {
    const pattern = RegExp(name + "=.[^;]*");
    const matched = document.cookie.match(pattern);
    if(!matched) return false;
    const cookie = matched[0].split('=')
    return cookie[1];
}